import * as React from 'react';
import OrganizationUser from '../models/OrganizationUser';
import { identity } from '../../core/auth/identityAuth';
import HttpService from '../../../modules/core/services/HttpService';
import Loading from '../../shared/components/loading/Loading';
import * as moment from 'moment';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import BreadCrumb from '../../shared/components/BreadCrumb'
import { NavLink } from 'react-router-dom'

import {
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper
} from '@material-ui/core';

import { withStyles, StyleRules } from '@material-ui/core/styles';

interface IState {
  users: OrganizationUser[],
  isLoading: boolean
}
const httpService = HttpService.Instance;

const styles: StyleRules = {
  container: {
    justifyContent: 'flex-start',
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    boxSizing: 'border-box',
    width: 'calc(100% + 24px)',
    margin: '-12px'
  },
  item1: {
    flex: '0 0 0',
    padding: '12px',
    boxSizing: 'border-box'
  },
  item2: {
    flex: '1 1 0',
    padding: '12px',
    boxSizing: 'border-box',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
};

class OrganizationUsers extends React.Component<any, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      users: [],
      isLoading: true
    }
    this.getUsers = this.getUsers.bind(this);
  }
  public AddUserLink = (props: any) => <NavLink to="users/add" {...props} />

  public componentDidMount() {
    this.getUsers();
  }

  public getUsers() {
    if (identity['nxt:entity:id']) {
      httpService.get(process.env.REACT_APP_API_URL + 'users?pagesize=1000')
        .then((response: Response) => response.json())
        .then((data: any) => {
          if (data.users) {
            data.users.sort((a: any, b: any) => {
              const subdivisionA = a.subdivision.toUpperCase();
              const subdivisionB = b.subdivision.toUpperCase();
              if (subdivisionA < subdivisionB) {
                return -1;
              }
              if (subdivisionA > subdivisionB) {
                return 1;
              }
              return 0;
            });
          }
          this.setState({ ...this.state, users: data.users, isLoading: false })
        })
    }
  }

  public render() {
    return (
      <div>
        <Typography color="textSecondary" gutterBottom={true}>
          <BreadCrumb
            value='Organization'
            to='/organization/settings/'
          />
          Users
        </Typography>
        <div className='padding-bottom-8'>
          <Button component={this.AddUserLink} variant="outlined" color="secondary"><PersonAddIcon className='margin-right-8' /> Add User </Button>
        </div>
        {this.state.isLoading &&
          <div>
            <Loading />
          </div>
        }
        {!this.state.isLoading &&
          <Paper>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>State</TableCell>
                  <TableCell>Added</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Sub Division</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.users.map((user) => {
                  const UserLink = (props: any) => <NavLink to={'users/' + user.id} {...props} />
                  return (
                    <TableRow key={user.id}>
                      <TableCell component="th" scope="row">
                        {user.firstName} {user.lastName}
                      </TableCell>
                      <TableCell>
                        {user.state.name}
                      </TableCell>
                      <TableCell>{moment(user.dateAdded).fromNow()}</TableCell>
                      <TableCell>
                        <a href={"mailto:" + user.email} style={{ color: 'inherit', textDecoration: 'inherit' }} >
                          {user.email}
                        </a>
                      </TableCell>
                      <TableCell>{user.subdivision}</TableCell>
                      <TableCell>
                        <Button component={UserLink}>
                          Edit
                        </Button>
                      </TableCell>
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </Paper>
        }
      </div>
    )
  }
}

export default withStyles(styles)(OrganizationUsers)



// WEBPACK FOOTER //
// ./src/modules/organization/pages/OrganizationUsers.tsx